"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var Snippets = require("snippets");
var React = require("react");
var BundleCollectionPageTemplate = /** @class */ (function (_super) {
    __extends(BundleCollectionPageTemplate, _super);
    function BundleCollectionPageTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            collectionBundle: _this.props.data.page.metafields.bundle ? _this.props.data.page.metafields.bundle.collection_bundle : null,
            bundle: _this.props.data.section.bundleSection
        };
        return _this;
    }
    BundleCollectionPageTemplate.prototype.render = function () {
        var page = this.props.data.page;
        var bundle = this.state.bundle;
        var collectionBundle = this.state.collectionBundle;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement("div", { className: "bundle-collection" },
                React.createElement(Snippets.Container, { width: "full", className: "" },
                    React.createElement("div", { className: "relative md:max-h-24 overflow-hidden " + (bundle && bundle.settings.contentColour ? "text-" + bundle.settings.contentColour : "text-black") },
                        bundle && bundle.settings.desktopBanner ? (React.createElement("div", { className: "relative md:h-24 h-14" },
                            React.createElement(Snippets.Image, { alt: "faqDesktopBanner", className: "bg-cover bg-center absolute pin hidden md:block", src: bundle.settings.desktopBanner }),
                            React.createElement(Snippets.Image, { alt: "faqMobileBanner", className: "block md:hidden", src: bundle.settings.mobileBanner ? bundle.settings.mobileBanner : bundle.settings.desktopBanner }))) : (React.createElement("div", { className: "content-placeholder w-full md:h-24 h-14" })),
                        React.createElement("div", { className: "max-w-xl mx-auto flex items-center absolute pin z-10 mlg:px-11 " + (bundle && bundle.settings.contentColour ? "text-" + bundle.settings.contentColour : "text-black") },
                            React.createElement(Snippets.Heading, { size: "h2", tag: "h1", className: "font-extrabold lg:px-11 px-4 md:text-48 text-xmd" }, page.title)))),
                React.createElement("section", { className: "bg-very-light-pink py-3-2 w-full overflow-auto" },
                    React.createElement("div", { className: "max-w-xl mx-auto mlg:px-11 md:px-3 px-1-6" },
                        React.createElement("div", { className: "md:h-auto px-0-8 md:px-2-4 md:w-4/5 pb-2" },
                            React.createElement("div", { className: "w-full page-content " }, next_components_1.ShopifyNext.Utils.parseHTML(page.content))),
                        collectionBundle ? (React.createElement("div", { className: "w-full " },
                            React.createElement("div", { className: "w-full md:mx-1-2" },
                                React.createElement("div", { className: "flex flex-wrap border-t pt-2 border-secondary-blue-grey" }, collectionBundle.map(function (team) { return (React.createElement("div", { className: "block mb-0-8 md:mb-2-4 w-1/2 md:w-1/4 px-0-8 md:px-1-2" },
                                    React.createElement("a", { className: "bg-arctic w-full", href: team.collection },
                                        React.createElement("div", { className: "w-full flex justify-center py-2-4" },
                                            React.createElement("img", { src: team.logo, className: "w-1/2" })),
                                        React.createElement("div", { className: "px-0-8 py-1-6 text-center" },
                                            React.createElement("h4", { className: "font-semibold text-base md:text-md tracking-normal leading-1.29 " }, team.title))))); }))))) : null)))));
    };
    return BundleCollectionPageTemplate;
}(React.Component));
exports.BundleCollectionPageTemplate = BundleCollectionPageTemplate;
